import { useI18n } from "@/i18n/I18nProvider";
import { SEO } from "@/components/SEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { InternalLinks } from "@/components/InternalLinks";

export function ContactPage() {
  const { t, lang, prefix } = useI18n();
  const isSv = lang === "sv";
  const title = isSv ? "Kontakta CasinoMenu.se" : "Contact CasinoMenu.se";
  const desc = isSv
    ? "Kontakta CasinoMenu.se för redaktionella frågor, partnerskap och pressärenden."
    : "Contact CasinoMenu.se for editorial questions, partnerships and press matters.";
  return (
    <div className="container-page py-8">
      <SEO title={title} description={desc} />
      <Breadcrumbs items={[{ label: t("nav.home"), href: prefix }, { label: title }]} />
      <h1 className="mt-3 text-3xl font-extrabold md:text-4xl">{title}</h1>
      <p className="mt-2 max-w-3xl text-ink-700">{desc}</p>

      <section className="mt-8 grid gap-4 md:grid-cols-3">
        <div className="card p-5">
          <p className="text-xs font-semibold uppercase tracking-wider text-brand-700">
            {isSv ? "Redaktion" : "Editorial"}
          </p>
          <p className="mt-2 text-lg font-bold text-ink-900">redaktion@casinomenu.se</p>
          <p className="mt-1 text-sm text-ink-600">
            {isSv ? "Tips, frågor om innehåll, rättningar." : "Tips, content questions, corrections."}
          </p>
        </div>
        <div className="card p-5">
          <p className="text-xs font-semibold uppercase tracking-wider text-brand-700">
            {isSv ? "Partner" : "Partnerships"}
          </p>
          <p className="mt-2 text-lg font-bold text-ink-900">partner@casinomenu.se</p>
          <p className="mt-1 text-sm text-ink-600">
            {isSv ? "Affiliate, brand-listning, samarbeten." : "Affiliate, brand listings, partnerships."}
          </p>
        </div>
        <div className="card p-5">
          <p className="text-xs font-semibold uppercase tracking-wider text-brand-700">
            {isSv ? "Press" : "Press"}
          </p>
          <p className="mt-2 text-lg font-bold text-ink-900">press@casinomenu.se</p>
          <p className="mt-1 text-sm text-ink-600">
            {isSv ? "Mediaförfrågningar, intervjuer, statistik." : "Media inquiries, interviews, statistics."}
          </p>
        </div>
      </section>

      <article className="prose prose-ink mt-10 max-w-3xl [&>h2]:mt-10 [&>h2]:mb-3 [&>h2]:text-2xl [&>h2]:font-bold [&>p]:my-3">
        <h2>{isSv ? "Svarstid" : "Response time"}</h2>
        <p>
          {isSv
            ? "Vi svarar på e-post inom 1–3 arbetsdagar. Är ditt ärende brådskande — exempelvis om du upptäckt en faktafel eller en bruten länk — skriv ”BRÅDSKANDE” i ärenderaden så prioriterar vi."
            : "We answer emails within 1–3 business days. If your matter is urgent — for example a factual error or a broken link — write ”URGENT” in the subject line and we prioritise."}
        </p>
        <h2>{isSv ? "Vi är inte ett casino" : "We are not a casino"}</h2>
        <p>
          {isSv
            ? "CasinoMenu.se är en jämförelseplattform, inte en speloperatör. Har du frågor om en specifik bonus, ett uttag eller ett kontosaldo måste du kontakta operatören direkt — vi har ingen tillgång till dina spelkonton."
            : "CasinoMenu.se is a comparison platform, not a gambling operator. If you have questions about a specific bonus, a withdrawal or an account balance, contact the operator directly — we have no access to your gambling accounts."}
        </p>
        <h2>{isSv ? "Behöver du stöd vid spelproblem?" : "Need help with gambling problems?"}</h2>
        <p>
          {isSv
            ? "Ring Stödlinjen på 020-81 91 00. Det är gratis, anonymt och bemannat av professionella rådgivare. Du kan också chatta eller mejla via stodlinjen.se."
            : "Call Stödlinjen at 020-81 91 00. It is free, anonymous and staffed by professional counsellors. You can also chat or email via stodlinjen.se."}
        </p>
      </article>

      <InternalLinks context="static" />
    </div>
  );
}
